import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async requestsAccessToProject(context, data) {
      try {
        const response = await axios.post('/access-projects', data, { withCredentials: true });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async getCfaRealitycaptureIdByBim360ProjectId(context, bim360ProjectId) {
      try {
        const response = await axios.get(`/access-projects/${bim360ProjectId}`, { withCredentials: true });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async requestsAccessActionToProject(context, { token, action, reason }) {
      try {
        const response = await axios.patch(`/access-projects/${token}/${action}`, { reason }, { withCredentials: true });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async verifyFolderPermissions(context, projectId) {
      try {
        const response = await axios.get(`/access-projects/${projectId}/verify-folder-permissions`, { withCredentials: true });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async getRequestsAccess() {
      try {
        const response = await axios.get('/access-projects', { withCredentials: true });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
